<template>
  <div>
    <Layout>
    <PageHeader :title="'B2B Sipariş Listesi'" :items="breadcrumbArray"></PageHeader>
    <v-app>
      <div class="row">
      <div class="col-lg-12">
        <ResultsWithMixin :listType="'b2bSiparisList'"></ResultsWithMixin>
      </div>
    </div>
    </v-app>
    
  </Layout>
    
  </div>  
</template>

<script>
import Layout from "@/pages/layout/main.vue";
import PageHeader from "@/components/page-header";
// import Results from "@/components/orders/B2BOrders/Results.vue"
import ResultsWithMixin from "@/components/orders/B2BOrders/ResultsWithMixin.vue";


export default {
  page: {
    title: "B2B Siparişleri",
    meta: [{name: "b2bOrderList", content: "B2B Siparişleri"}],
  },
  components:{
    Layout,
    PageHeader,
    // Results
    ResultsWithMixin
  },
  data(){
    return {
      breadcrumbArray: [
        {
          text: "Siparişler",
          active: false,
        },
        {
          text: "B2B Sipariş Listesi",
          active: true,
        },
      ],
    }
  },

  computed:{
    
  },
  methods:{
    
  }
}

</script>